/* eslint-disable no-param-reassign */
import {
  State, CurrentState, SelectingState,
} from '../menu-list.slice';

export default function cancelAllExisting(state: State): void {
  if (
    state.current === CurrentState.selecting
    && state.selectingState === SelectingState.allExisting
  ) {
    state.selected = [];
    state.selectingState = SelectingState.simple;
  }
}
